
































import Vue from 'vue';
import Component from 'vue-class-component';
import {
  acceptedModule, acceptedState,
  authModule,
  challengeModule, challengesState, followedModule,
  tasksModule,
  tasksState, userModule,
  userState
} from '@/utils/store-acessor';
import {ChallengeModel} from '@/models/challenge.model';
import {TaskModel} from '@/models/task.model';
import TaskCard from '@/components/Challenges/tabs/tasks/TaskCard.vue';
import TaskDialog from '@/components/Challenges/tabs/tasks/TaskDialog.vue';
import ListScaffold from '@/components/Shared/ListScaffold.vue';
import {Watch} from 'vue-property-decorator';
import {bottomVisible} from '@/utils/utils';

@Component({
  components: {ListScaffold, TaskDialog, TaskCard}
})
export default class ChallengeTasks extends Vue {

  @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;
  @challengeModule.Getter('selectedChallenge') challenge!: ChallengeModel;
  @acceptedModule.Getter('acceptedChallenges') acceptedChallenges!: ChallengeModel[];
  @userModule.Getter('canAcceptChallenges') canAccept!: boolean;
  @acceptedModule.Getter('userHasAccepted') userHasAccepted!: (challengeId: number) => boolean;
  @tasksModule.Getter('tasks') tasks!: TaskModel[];
  @tasksModule.Getter('lastPage') lastPage!: number;
  @tasksModule.Getter('currentPage') page!: number;
  @tasksModule.Getter('loading') loading!: boolean;

  task: TaskModel | null = null;
  openModal = false;

  async mounted() {
    if (this.challenge?.id) {
      await tasksState.fetchTasks({
        challengeId: this.challenge.id,
        pageParams: {
          page: 1
        }
      })
    }
    window.addEventListener('scroll', () => {
      if (bottomVisible()) {
        this.inBottom()
      }
    })
  }

  async inBottom() {
    if ((this.page < this.lastPage) && !this.loading) {
      await challengesState.fetchAll({page: this.page + 1});
    }
  }

  taskSelected(task: TaskModel) {
    this.task = task;
    this.openModal = true;
  }

  taskUpdate(event: TaskModel) {
    this.task = event
  }
}
